module.exports = __webpack_public_path__ + "img/Cheer Megaphone59.b1e24753.jpg";